<div
  style="
    font-family: 'Roboto';
    background: url('../assets/img/signup-background.jpg');
    background-size: cover;
    background-repeat: no-repeat;
  "
  class="shippn-sign-in-page-main-wrapper"
>
  <div class="container shippn-homepage-container signin-background-woman">
    <div class="row">
      <div style="margin-top: 20px" class="col-md-6 offset-md-6">
        <div class="row">
          <div style="text-align: left" class="col-md-12">
            <h1 style="font-weight: bold; font-size: 22px">Sign In</h1>
            <h5 style="font-weight: 400; font-size: 14px">
              Don't have an account?
              <a [routerLink]="['/', 'signup']" style="cursor: pointer"
                >Sign up</a
              >
              now!
            </h5>
          </div>
        </div>
        <form ngNativeValidate [formGroup]="form">
          <div class="row">
            <div class="col-md-12">
              <h5
                style="
                  font-weight: 400;
                  font-size: 14px;
                  margin-bottom: 0;
                "
              >
                or sign in with your e-mail and password
              </h5>
            </div>

            <div style="margin-top: 15px" class="col-md-12">
              <div class="input_container">
                <input
                  style="padding-right: 35px"
                  formControlName="email"
                  [ngClass]="{
                    'shippn-border-red':
                      form.get('email').touched && form.get('email').invalid
                  }"
                  required
                  type="email"
                  class="form-control shippn-input bg-white"
                  placeholder="Email"
                  data-cy="login-username-field"
                />
                <i
                  style="right: 19px"
                  *ngIf="form.get('email').touched && form.get('email').invalid"
                  id="input_img"
                  class="fas fa-times"
                ></i>
              </div>
            </div>

            <div style="margin-top: 15px" class="col-md-12">
              <div class="input_container">
                <input
                  formControlName="password"
                  [ngClass]="{
                    'shippn-border-red':
                      form.get('password').touched &&
                      form.get('password').invalid
                  }"
                  name="signupPassword"
                  required
                  type="password"
                  class="form-control shippn-input bg-white"
                  placeholder="Password"
                  data-cy="login-password-field"
                />
                <i
                  style="right: 19px"
                  *ngIf="
                    form.get('password').touched && form.get('password').invalid
                  "
                  id="input_img"
                  class="fas fa-times"
                ></i>
              </div>
            </div>

            <div style="margin-top: 15px; padding: 0 15px">
              <ngx-recaptcha2
                #captchaElem
                [siteKey]="recaptchaCheckboxKey"
                [useGlobalDomain]="false"
                formControlName="recaptcha"
                (expire)="resetCaptcha()"
                (error)="resetCaptcha()"
                captchaId="signincaptcha"
              >
              </ngx-recaptcha2>
              <span
                *ngIf="
                  form.get('recaptcha').touched && form.get('recaptcha').invalid
                "
                style="color: red; font-size: 14px"
                >This field is required.</span
              >
            </div>

            <div style="margin-top: 15px" class="col-md-12">
              <button
                *ngIf="passingSignupData == false"
                style="
                  background-color: #ff6c36;
                  padding: 8px 12px;
                  border: #ff6c36;
                  color: white;
                  width: 100%;
                  font-weight: 600;
                "
                type="submit"
                class="btn"
                data-cy="login-submitBtn-field"
                (click)="signIn()"
              >
                Sign In
              </button>

              <a
                *ngIf="passingSignupData == true"
                style="
                  background-color: #ff6c36;
                  padding: 22px 12px;
                  border: #ff6c36;
                  color: white;
                  width: 100%;
                  font-weight: 600;
                "
                type="button"
                class="btn btn-loading-white"
              ></a>
            </div>
            <div
              style="margin-top: 15px; text-align: center"
              class="col-md-6"
              *ngIf="!platformisWebView"
            >
              <a
                (click)="loginWithFacebook()"
                style="
                  font-size: 14px;
                  padding: 6px 15px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 10px;
                  height: 40px;
                "
                class="btn btn-facebook"
                ><i class="fab fa-facebook-square" style="font-size: 24px"></i
                >Connect with Facebook</a
              >
            </div>
            <div
              style="margin-top: 15px; margin-bottom: 15px; text-align: center"
              class="col-md-6"
              *ngIf="!platformisWebView"
              (click)="loginWithGoogle()"
            >
              <div
                style="
                  background-color: #f2f2f2;
                  border: 1px solid #dedede;
                  font-size: 14px;
                  border-radius: 5px;
                  cursor: pointer;
                "
              >
                <img src="assets/img/sign_in/web_neutral_sq_na.svg" alt="" />
                Continue with Google
              </div>
            </div>
            <div
              style="text-align: right; margin-top: 5px"
              class="col-md-12"
              [ngClass]="{ 'webview-margin-fixer': platformisWebView }"
            >
              <a (click)="openDialog()"
                style="cursor: pointer; font-size: 13px; color: #337ab7"
                >Forgot Password</a
              >
            </div>
            <div class="col-12">
              <div class="shippnpilot-signin-wrapper">
                <app-shippnpilot-widget
                  [shippnpilotWidgetType]="'both'"
                ></app-shippnpilot-widget>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Forgot Password Modal -->
<div
  class="modal fade"
  id="forgotPasswordModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div style="max-width: 600px" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background: #222222" class="modal-header">
        <h5
          style="color: white; padding-left: 15px"
          class="modal-title"
          id="exampleModalLabel"
        >
          Forgot Password
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span style="color: white" aria-hidden="true">&times;</span>
        </button>
      </div>

      <form ngNativeValidate [formGroup]="forgotPasswordForm">
        <div style="padding-left: 50px; padding-right: 50px" class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <p
                style="
                  margin-bottom: 0px;
                  font-size: 16px;
                  font-weight: 300;
                  text-align: left;
                "
              >
                Enter your registered email address. We'll send you an email to
                reset your password.
              </p>
            </div>
          </div>

          <div class="row">
            <div style="margin-top: 10px" class="col-12 col-lg-12">
              <p
                style="
                  color: black;
                  text-align: left;
                  font-size: 16px;
                  font-weight: bold;
                  margin-bottom: 5px;
                "
              >
                Email
              </p>
              <input
                type="email"
                formControlName="email"
                [ngClass]="{
                  'shippn-border-red':
                    forgotPasswordForm.get('email').touched &&
                    forgotPasswordForm.get('email').invalid
                }"
                placeholder="Email"
                class="form-control form-control-sm shippn-input"
              />
            </div>
          </div>
          <div class="row">
            <div style="margin-top: 10px" class="col-md-12">
              <button
                style="
                  width: 100px;
                  font-size: 16px;
                  font-weight: normal;
                  height: 38px;
                "
                (click)="forgotPassword()"
                class="btn shippn-from-to-area-go-btn"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<button
  style="width: 0; height: 0; display: none"
  id="socialUpdateModalTriggerBtn"
  data-toggle="modal"
  data-target="#socialUpdateModal"
></button>
<!-- Social Update Modal -->
<div
  class="modal fade"
  id="socialUpdateModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div style="max-width: 600px" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div style="background: #222222" class="modal-header">
        <h5
          style="color: white; padding-left: 15px"
          class="modal-title"
          id="exampleModalLabel"
        >
          Update Profile
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span style="color: white" aria-hidden="true">&times;</span>
        </button>
      </div>
      <form ngNativeValidate [formGroup]="socialUpdateForm">
        <div style="padding-left: 50px; padding-right: 50px" class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <p
                style="
                  margin-bottom: 0px;
                  font-size: 16px;
                  font-weight: 300;
                  text-align: left;
                "
              >
                Enter your email address
              </p>
            </div>
          </div>
          <div class="row">
            <div style="margin-top: 10px" class="col-12 col-lg-12">
              <p
                style="
                  color: black;
                  text-align: left;
                  font-size: 16px;
                  font-weight: bold;
                  margin-bottom: 5px;
                "
              >
                Email
              </p>
              <input
                type="email"
                formControlName="email"
                [ngClass]="{
                  'shippn-border-red':
                    socialUpdateForm.get('email').touched &&
                    socialUpdateForm.get('email').invalid
                }"
                placeholder="Email"
                class="form-control form-control-sm shippn-input"
              />
            </div>
          </div>
          <div class="row">
            <div style="margin-top: 10px" class="col-md-12">
              <button
                style="
                  width: 100px;
                  font-size: 16px;
                  font-weight: normal;
                  height: 38px;
                "
                (click)="updateSocialLoginProfile()"
                class="btn shippn-from-to-area-go-btn"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Facebook Authorization Waiting Modal-->
<button
  style="width: 0; height: 0; display: none"
  id="facebookLoginStatusModalBtn"
  data-toggle="modal"
  data-target="#facebookLoginStatusModal"
></button>
<!-- Modal -->
<div
  class="modal fade"
  id="facebookLoginStatusModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div style="max-width: 600px" class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" style="background: #222222">
        <h5
          style="color: white; padding-left: 15px"
          class="modal-title"
          id="exampleModalLabel"
        >
          Connect with Facebook
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span style="color: white" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div
          style="text-align: left; max-height: 500px; overflow-y: auto"
          class="col-md-12"
        >
          <div
            style="
              color: #0f0f0f;
              font-size: 15px;
              font-weight: 300;
              margin-top: 20px;
              margin-bottom: 20px;
            "
            *ngIf="!facebookLoginErrorMessage"
          >
            <p style="text-align: center">
              Waiting for Facebook authorization.
            </p>
            <div
              style="
                background-image: url(../../assets/img/loading-black.gif);
                background-repeat: no-repeat;
                background-position: center;
                height: 35px;
                width: 100%;
              "
            ></div>
          </div>
          <p
            *ngIf="facebookLoginErrorMessage"
            style="
              color: #0f0f0f;
              font-size: 15px;
              font-weight: 300;
              margin-top: 20px;
              margin-bottom: 20px;
            "
          >
            {{ facebookLoginErrorMessage }}
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button
          style="
            width: 100px;
            font-size: 16px;
            font-weight: normal;
            height: 38px;
          "
          data-dismiss="modal"
          class="btn shippn-from-to-area-go-btn pull-right"
          id="facebookLoginCloseModalBtn"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
